jQuery( function( $ ) {
	$( document ).ready( function() {

		/**
		 * Code fired on homepage
		 * @author Przemysław Hernik
		 */

		homeJS = ( function() {

			var

				init = function() {
				},

				finalize = function() {

				}
			;

			return {
				init: init,
				finalize: finalize
			};

		}() );

	});
});
